/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, detail: NonNullable<unknown> }} Workout_Correct_OpenInputs */

const en_us2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correct set ${i?.n}, ${i?.detail}`)
};

const pt_br2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrigir série ${i?.n}, ${i?.detail}`)
};

const es_419_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corregir serie ${i?.n}, ${i?.detail}`)
};

const pt_pt2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrigir série ${i?.n}, ${i?.detail}`)
};

const fr_fr2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corriger la série ${i?.n}, ${i?.detail}`)
};

const de_de2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Satz ${i?.n} korrigieren, ${i?.detail}`)
};

const it_it2_workout_correct_open = /** @type {(inputs: Workout_Correct_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correggi serie ${i?.n}, ${i?.detail}`)
};

/**
* | output |
* | --- |
* | "Correct set {n}, {detail}" |
*
* @param {Workout_Correct_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_correct_open = /** @type {((inputs: Workout_Correct_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Correct_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_correct_open(inputs)
	if (locale === "es-419") return es_419_workout_correct_open(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_correct_open(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_correct_open(inputs)
	if (locale === "de-DE") return de_de2_workout_correct_open(inputs)
	if (locale === "it-IT") return it_it2_workout_correct_open(inputs)
	return en_us2_workout_correct_open(inputs)
});
export { workout_correct_open as "workout.correct_open" }